import { useEffect, useState } from 'react';
import dynamicfunction from '../../utils/dynamicfunction';
import { useDispatch, useSelector } from 'react-redux';
import { getContentKeyAccToLang } from '../../utils/utils';
import {
  buyOrderFunds,
  generateFundSuitability,
  getBuyCloseEndFunds,
} from '../../store/actions/fund-action';
import { useLocation, useNavigate } from 'react-router';
import { languages } from '../../config/config';
import { clientSuspendedToast } from '../../utils/functions';

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { TextWeight, isArabic } = dynamicfunction();

  const { fundsContent, language } = useSelector((state) => state.content);
  const { user } = useSelector((state) => state.common);

  const {
    buyCloseEndFunds,
    fund_loading,
    fund_detail,
    fund_document_loading,
    suitability_data,
  } = useSelector((state) => state.fund);

  const [reviewModal, setReviewModal] = useState(false);
  const [subscribeData, setSubscribeData] = useState(null);
  const [image, setImage] = useState(null);
  const [isSuitabilityModal, setIsSuitabilityModal] = useState(false);

  const pathname = useLocation();

  const isBuyOrder = pathname?.pathname === '/funds/buy-order';

  useEffect(() => {
    if (user?.isClientSuspended && (isBuyOrder)) {
      clientSuspendedToast(isArabic);
      navigate(-1)
    }
  }, [user?.isClientSuspended])

  useEffect(() => {
    dispatch(getBuyCloseEndFunds(language === languages.eng ? 3 : 4));
  }, []);

  const toogleReviewModal = () => setReviewModal(!reviewModal);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      fundsContent?.web_funds_buy_order?.data?.attributes,
      key,
      isArabic
    );
  };

  const handleReviewOrder = (values, functions) => {
    if (values?.read_suitability_report) {
      setSubscribeData({ ...values, resetForm: functions?.resetForm });
      toogleReviewModal();
    } else {
      handleGenerateSuitability();
    }
  };

  const handleGenerateSuitability = () => {
    dispatch(
      generateFundSuitability(fund_detail?.subRequestId, () => {
        setIsSuitabilityModal(true);
      })
    );
  };

  const onVerify = () => {
    const api_data = new FormData();
    api_data.append('FundId', subscribeData?.fundName?.fundId);
    api_data.append('UnitsRequested', subscribeData?.amount);
    api_data.append('PriceRequested', 0);
    api_data.append('SuitabilityResult', suitability_data?.isSutibile);
    api_data.append('SuitabilityScore', suitability_data?.jsrS_sutabilityScore);
    api_data.append('SuitabilityUuid', suitability_data?.jsrS_ReportRefUUID);
    // api_data.append('files', image);
    api_data.append('investorTypeId', user?.investorTypeId);
    dispatch(
      buyOrderFunds(api_data, (val) => {
        subscribeData?.resetForm && subscribeData?.resetForm();
        toogleReviewModal();
        navigate('/funds/internal-unit-exchange');
      })
    );
  };

  const subscription = fund_detail?.feeApplicable
    ? Number(subscribeData?.amount) * fund_detail?.feeValueInPer
    : 0;
  const vat = fund_detail?.vatApplicable
    ? (Number(subscription) * fund_detail?.vatValueInPer) / 100
    : 0;
  // const total_amount = Number(subscribeData?.amount) + vat + subscription;

  return {
    dispatch,
    buyCloseEndFunds,
    fund_detail,
    TextWeight,
    fund_loading,
    subscribeData,
    getContentKey,
    handleReviewOrder,
    onVerify,
    reviewModal,
    setReviewModal,
    toogleReviewModal,
    fund_document_loading,
    subscription,
    vat,
    isSuitabilityModal,
    setIsSuitabilityModal,
    handleGenerateSuitability,
    image,
    setImage,
    navigate,
    isArabic,
  };
};
